import { render, staticRenderFns } from "./detail-item.vue?vue&type=template&id=3a68b30e&scoped=true"
import script from "./detail-item.vue?vue&type=script&lang=js"
export * from "./detail-item.vue?vue&type=script&lang=js"
import style0 from "./detail-item.vue?vue&type=style&index=0&id=3a68b30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a68b30e",
  null
  
)

export default component.exports